import { NgModule } from '@angular/core';
import { TopbarComponent } from './components/topbar/topbar.component';
import { PublicNavigationComponent } from './components/public-navigation/public-navigation.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpClient, HttpClientModule } from '@angular/common/http';

@NgModule({
  imports: [CommonModule, RouterModule, HttpClientModule],
  exports: [TopbarComponent, PublicNavigationComponent],
  declarations: [TopbarComponent, PublicNavigationComponent],
  providers: [],
})
export class SharedModule {}
